const escapeDoubleQuote = text => text ? text.replace(/"/g, '&quot;') : '';

export default escapeDoubleQuote;
